<template>
	<!-- 这是右边引入的表格 -->
	<div class="equipment-manage" :class="{'app-region blank-t-v blank-l-h blank-r-h': !communityId}">
		<a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">

			<a-col :span="24" :xl="8">
				<a-row :gutter="[8, 8]">
					<a-col>
						<p>设备类型</p>
					</a-col>
					<a-col>
						<a-select class="app-block" placeholder="请选择设备类型" v-model="table.search.device_type_id">
							<a-select-option :value="value.id" v-for="value in deviceOptions" :key="value.id">
								{{value.name}}</a-select-option>
						</a-select>
					</a-col>
				</a-row>
			</a-col>

			<a-col :span="24" :xl="8">
				<a-row :gutter="[8, 8]">
					<a-col>
						<p>设备名称</p>
					</a-col>
					<a-col>
						<a-input v-model="table.search.name" placeholder="请输入设备名称"></a-input>
					</a-col>
				</a-row>
			</a-col>

			<a-col :span="24" :xl="8">
				<a-row :gutter="[8, 8]">
					<a-col>
						<p>设备型号</p>
					</a-col>
					<a-col>
						<a-input v-model="table.search.device_model" placeholder="请输入设备型号"></a-input>
					</a-col>
				</a-row>
			</a-col>

			<a-col :span="24" :xl="8">
				<a-row :gutter="[8, 8]">
					<a-col>
						<p>设备品牌</p>
					</a-col>
					<a-col>
						<a-input v-model="table.search.brand" placeholder="请输入设备品牌"></a-input>
					</a-col>
				</a-row>
			</a-col>
			<a-col :span="24" :xl="8">
				<a-row :gutter="[8, 8]">
					<a-col>
						<p>空间位置</p>
					</a-col>
					<a-col>
						<a-input v-model="table.search.position" placeholder="请输入设备空间位置"></a-input>
					</a-col>
				</a-row>
			</a-col>

			<a-col :span="24" :xl="8">
				<a-row :gutter="[8, 8]">
					<a-col>
						<p>运行状态</p>
					</a-col>
					<a-col>
						<a-select class="app-block" v-model="table.search.run_state" placeholder="请选择设备运行状态">
							<a-select-option :value='0'>{{runningStatus(0)}}</a-select-option>
							<a-select-option :value='1'>{{runningStatus(1)}}</a-select-option>
						</a-select>
					</a-col>
				</a-row>
			</a-col>


			<a-col :span="24" :xl="8">
				<a-space>
					<a-button type="primary" @click="searchTable">查询</a-button>
					<a-button @click="resetSearchTable">重置</a-button>
				</a-space>
			</a-col>
		</a-row>

		<a-row class="mg-normal">
			<a-col>
				<a-space>
					<a-button type="primary" @click="newEquipment()">添加设备</a-button>
				</a-space>
			</a-col>
		</a-row>

		<a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data"
			rowKey="id" :pagination="table.page" @change="handlePageChange">
			<template slot="action" slot-scope="text, data">
				<a-space>
					<a-button type="link">详情</a-button>
					<a-button type="link">更多</a-button>
				</a-space>
			</template>
		</a-table>
	</div>
</template>

<script>
	import { runningStatus } from '@/io/dict.js'
	import Equipment from "@/io/equipment.js";
	import DeviceType from '@/io/device_type.js';

	export default {
		name: 'EquipmentManage',
		props: {
			communityId: {
				type: Number,
				default: null
			},
		},
		data() {
			let self = this;
			return {
				runningStatus,

				table: {
					loading: false,
					search: {
						device_type_id: null,
						name: null,
						device_model: null,
						brand: null,
						position: null,
						run_state: [],
					},

					page: {
						total: 0,
						current: 1,
						pageSize: 10,
						showQuickJumper: true,
						showSizeChanger: true,
						showTotal() {
							return `共${self.table.page.total}条`;
						}
					},
					data: [],
					columns: [
						{
							title: '项目名称',
							dataIndex: 'community_name'
						},
						{
							title: '设备类型',
							dataIndex: 'device_type.name'
						},
						{
							title: '设备名称',
							dataIndex: 'name'
						},
						{
							title: '设备型号',
							dataIndex: 'device_model'
						},
						{
							title: '设备品牌',
							dataIndex: 'brand'
						},
						{
							title: '空间位置',
							dataIndex: 'position'
						},

						{
							title: '运行状态',
							dataIndex: 'runningStatus'
						},
						{
							title: '操作',
							scopedSlots: {
								customRender: 'action'
							},
						}
					]
				},
				deviceOptions: [],
				equipOptions: [],
			}
		},
		
		watch: {
			communityId: {
				handler(newValue, oldValue) {
					if (newValue || this.$getCookie('communityId')) {
						this.searchTable();
					}
				},
				immediate: true
			}
		},
		activated() {
			if (this.communityId) {
				this.initData();
			}
		},
		mounted() {
			Promise.all([
				this.initDevice()
			]).then(() => {
				this.initData();
			});
		},
		methods: {
			//添加任务
			newEquipment() {
				this.table.page.current = 1;
				this.$router.push({
					name: 'NewEquipment'
				})
			},
			// 页面表格切换
			toPage(params) {
				if (this.communityId) {
					params = {
						...params,
						query: {
							community_id: this.communityId
						}
					}
				}
				this.$router.push(params);
			},
			searchTable() {
				this.table.page.current = 1;
				this.initData();
			},
			//这是搜索的是表格内的数据
			resetSearchTable() {
				this.table.search = {
					device_type_id: null,
					name: null,
					device_model: null,
					brand: [],
					position: null,
					run_state: [],
				};
				this.searchTable();
			},
			handlePageChange(page) {
				this.table.page.current = page.current;
				this.table.page.pageSize = page.pageSize;
				this.initData();
			},
			// 设备类型数据
			initDevice() {
				return DeviceType.listPage().then(res => {
					this.deviceOptions = res;
				}).catch(err => {})
			},
		
			initData() {
				this.table.loading = true;
				this.$emit('total', 0);
				Equipment.listPage(
					this.communityId,
					this.table.search.device_type_id,
					this.table.search.name,
					this.table.search.device_model,
					this.table.search.brand,
					this.table.search.position,
					this.table.search.run_state,
					this.table.page.current,
					this.table.page.pageSize
				).then(res => {
					// this.table.data = res.data
					this.table.data = res.data.map(val => {
						val.runningStatus= runningStatus(val.status)
						// val.run_state= runningStatus(val.state)
						return val;
					});
					// console.log('id11111',res)
					this.table.page.total = res.meta.pagination.total;
					this.$emit('total', res.meta.pagination.total);
				}).catch(err => {}).finally(() => {
					this.table.loading = false;
				});
			},

		},
	}
</script>

<style lang="less" scoped>

</style>
